'use client'
import { MultiSelectFormListStringFieldOneLineUiTest } from '@repo/ui'
import { useRouter, useSearchParams, usePathname } from 'next/navigation'

export default function CompanyFilterClient({ options, value }: { options: string[]; value: string[] }) {
  const router = useRouter()
  const search = useSearchParams()
  const pathname = usePathname()

  const setValue = (next: string[]) => {
    const p = new URLSearchParams(search.toString())
    next.length ? p.set('Company', next.join(',')) : p.delete('Company')
    router.push(`${pathname}?${p}`, { scroll: false })
  }

  return (
    <MultiSelectFormListStringFieldOneLineUiTest
      options={options}
      defaultValue={value}
      onValueChange={setValue}
      placeholder="Company"
      className="max-w-[280px]"
      popoverContentClassName="min-w-[348px]"
    />
  )
}
